export enum MARINE_ROUTES {
    MARINE_TRANSITION = "/marine-transition",
    MARINE_CARGO = "/marine-transition/marine-cargo-insurance-policy",
    MARINE_STOP = "/marine-transition/marine-sales-turnover-policy",
    MARINE_HULL = "/marine-transition/marine-hull-insurance",
  }
  